import script from "./prediction-drawer-single.vue?vue&type=script&lang=ts&setup=true"
export * from "./prediction-drawer-single.vue?vue&type=script&lang=ts&setup=true"

import "./prediction-drawer-single.vue?vue&type=style&index=0&id=fff23212&lang=scss&scoped=true"

import exportComponent from "D:\\web\\operation-platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fff23212"]])

export default __exports__